var $class="se2--wiztopic-event-list",$name="WiztopicEventList",$path="app/components/WiztopicEventList/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';
import ajax from 'app/modules/ajax';
import { wiztopicCardsElementSelector } from 'app/components/WiztopicEventList/config';
import './partials/wiztopicCard';

export default shell.registerComponent($this, ({ mount, addEventListener, configs }) => {
  mount((element) => {
    const viewMoreButtonSelector = '.load-more-button';
    const viewMoreButtonContainerSelector = '.load-more-button-wrap';
    const cardsContainerSelector = '.cards-container';
    const componentIndex = element.dataset?.componentId;
    // eslint-disable-next-line max-len
    const cardSelector = `.${wiztopicCardsElementSelector}.component-${componentIndex} .slide-container`; // '.sdl-wiztopic-press-releases_wiztopic-card'

    const viewMoreButtonElement = element.querySelector(viewMoreButtonSelector);
    const viewMoreButtonContainerElement = element.querySelector(viewMoreButtonContainerSelector);
    if (!viewMoreButtonContainerElement) return;
    const totalcardsAmount = element.dataset.cardAmount;
    let { skipCount } = element.dataset;
    const cardsContainerElement = element.querySelector(cardsContainerSelector);
    const url = new URL(window.location.href); // 'https://www.se.com/ww/en/about-us/newsroom/news/'
    const urlString = url.origin + url.pathname.replace(/index.jsp/gm, '');
    const urlSearchParam = `${url.search}`;

    const loadMoreCards = () => {
      viewMoreButtonElement.disabled = true;
      ajax.fetchText(`${urlString}${(urlSearchParam
        ? `${urlSearchParam}&` : '') || '?'}skip=${skipCount}`).then((content) => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(content, 'text/html');
        const cardsArray = htmlDocument.documentElement.querySelectorAll(cardSelector);
        cardsArray.forEach((card) => cardsContainerElement.appendChild(card));
        skipCount = cardsArray.length + Number(skipCount);
        if (skipCount >= totalcardsAmount) viewMoreButtonContainerElement.classList.add(configs.css.classNames.hide);
      }).finally(() => {
        viewMoreButtonElement.disabled = false;
      });
    };

    addEventListener(viewMoreButtonElement, 'click', loadMoreCards);
  });
});
